/* eslint-disable no-undef */

export default function initJsBridge() {
  /**
   * 注册事件
   * @param {*} callback
   */
  function setupWebViewJavascriptBridge(callback) {
    if (window.WebViewJavascriptBridge) {
      return callback(WebViewJavascriptBridge);
    }

    if (window.WVJBCallbacks) {
      return window.WVJBCallbacks.push(callback);
    }

    window.WVJBCallbacks = [callback];

    let WVJBIframe = document.createElement('iframe');

    WVJBIframe.style.display = 'none';
    WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__';
    document.documentElement.appendChild(WVJBIframe);
    setTimeout(() => {
      document.documentElement.removeChild(WVJBIframe);
    }, 0);
  }

  //原生调js
  window.bridgeRegisterHandler = function(option) {
    console.log(option);
    setupWebViewJavascriptBridge(bridge => {
      //oc调用Js的方法，并且有返回函数   callHeandler(方法名与app端保持一致)  data（IOS传过来的数据）
      bridge.registerHandler(option.method, (data, responseCallback) => {
        //js回调函数返回数据
        if (option.callback) {
          option.callback(data);
        }

        const responseData = { success: true };

        responseCallback(responseData, data);
      });
    });
  };

  /**
   * 传入的option对象格式
   * {
   *    method:[String],
   *    data:[Object],
   *    callback:[Function]
   * }
   */
  window.callNativePage = function(option) {
    console.log(option);
    setupWebViewJavascriptBridge(() => {
      window.WebViewJavascriptBridge.callHandler(option.method, option.data, responseData => {
        if (option.callback) {
          option.callback(responseData);
        }
      });
    });
  };

  // 注册给原生JS事件
  window.bridgeRegisterHandler({
    method: 'initBridge',
    callback(params) {
      // data : 原生传递给前端的data
      try {
        let appEnv = {};

        if (params instanceof Object) {
          appEnv = params;
        } else {
          appEnv = JSON.parse(params);
        }

        const { start_path } = appEnv;

        window.appEnv = appEnv;
        //window.location.href = start_path;
        //window.location.replace(start_path);
        localStorage.setItem('appEnv', JSON.stringify(appEnv));

        return true;
      } catch (err) {
        window.alert(err);
      }
    },
  });
}



// WEBPACK FOOTER //
// ./src/utils/jsbridge.js